import { footerInfo } from '@/mocks/home';

const navItems = [
  { label: '重磅推荐', href: '#carousel' },
  { label: '精彩视频', href: '#media' },
  { label: '精选内容', href: '#cards' },
  { label: '常见问题', href: '#faq' },
  { label: '热播榜单', href: '#ranking' },
  { label: '联系我们', href: '#contact' },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="text-2xl font-heading font-bold text-primary-400">海角网</span>
              <p className="mt-4 text-sm text-background-300 leading-relaxed">
                {footerInfo.description}
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
              <ul className="space-y-2">
                {navItems.map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => { e.preventDefault(); handleClick(item.href); }}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">内容分类</h4>
              <ul className="space-y-2">
                <li><span className="text-sm text-background-400">影视解说</span></li>
                <li><span className="text-sm text-background-400">搞笑日常</span></li>
                <li><span className="text-sm text-background-400">才艺展示</span></li>
                <li><span className="text-sm text-background-400">美食探店</span></li>
                <li><span className="text-sm text-background-400">旅行记录</span></li>
                <li><span className="text-sm text-background-400">萌宠乐园</span></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-500">携手优质平台，共创精彩内容</p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">{footerInfo.copyright}</p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-600 cursor-pointer hover:text-background-400 transition-colors">用户协议</span>
              <span className="text-xs text-background-600 cursor-pointer hover:text-background-400 transition-colors">隐私政策</span>
              <span className="text-xs text-background-600 cursor-pointer hover:text-background-400 transition-colors">版权声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}